export default {
  title: {
    confirmUpdateSelfResumeTitle: 'Does it update its own resume ?'
  },
  tabTitle: {
    index: 'My Profile',
    resumeAdd: 'Add Resume',
    resumeEdit: 'Edit Resume',
    submitResume: 'Submit Resume',
    applySuccess: 'Application Completed',
    editSuccess: 'Completed',
    importResume: 'Import Resume'
  },
  homeMenu: {
    name: 'My Resume',
    desc: 'Create / update my resume'
  },
  label: {
    age: 'age',
    submitTitle: 'Submit / Upload Resume',
    uploadResume: 'Upload Resume',
    emailAddress: 'Email',
    phoneNumber: 'Mobile Number',
    currentCompany: 'Current Company',
    currentPosition: 'Current Position',
    referralReason: 'Referral Reason',
    upload: 'upload',
    referralSuccess: 'Candidate resume is successfully uploaded. Please remind candidate to check the auto Email from the system and accept your consent. Your referral will be completed with the consent of referee. Thank you for your support!',
    uploadSuccess: 'Upload successfully',
    applySuccess: 'Application Completed!',
    successDescription: 'Thank you for applying to {title} at {company}.Your application has been successfully submitted.',
    invitationUrl: 'We appreciate you taking the time to apply to us, we’d love to know about your experience and how we can make it even better. Please take 90 seconds to share your feedback with us by taking our short survey. Please click <a href="{invitationUrl}" target="_blank" >HERE</a> to start sharing.',
    alreadyApplied: 'You Have Already Applied for This Job',
    appliedDescription: 'You have already successfully applied for this job. Please do not submit a duplicate application. You may view your application status in your application history.',
    thankApply: 'Thank you! ',
    assessmentDescription: 'You application has been submitted, good luck.',
    assessmentDescriptionTip: 'To improve your visibility, we encourage you to take this short (10-15 min) personality assessment. Upon completion, you will receive your own personal development report! ',
    doAssessment: 'Go to Assessment',
    moreInfo: 'More Information: ',
    seeAllJobs: 'See All Jobs',
    coachAI: 'Please use WeChat to scan the QR code to participate in the AI interview',
    followUs: 'Follow us on WeChat!',
    congratulations: 'Congratulations!',
    editResumeSuccess: 'You have completed your profile.',
    personal: 'My Info',
    refereeInfo: 'Candidate Info',
    firstName: 'First Name',
    lastName: 'Last Name',
    applying: 'Application in progress, please do not leave.',
    onRunningEightfoldTip: 'Register in EF PCS using the same email to track your application.'
  },
  placeholder: {
    input: 'input',
    select: 'select',
    startDate: 'start date',
    endDate: 'end date',
    currencyUnit: 'Currency'
  },
  btn: {
    seeDashboard: 'View More Jobs',
    moreReferral: 'Make Another Referral',
    toPersonalHome: 'View Dashboard',
    viewReport: 'View My Report',
    homePage: 'My Home Page',
    jobList: 'Back to Job List',
    continueApply: 'CONTINUE APPLY OTHER JOBS',
    reset: 'Reset',
    confirm: 'Confirm',
    addGroup: 'Add Group',
    deleteGroup: 'Delete Group'
  },
  tips: {
    uploadResume: 'Click or drag and drop files here to ',
    submitTips: 'Please upload the the resume of your referral and submit.',
    referralSuccessTips: 'Thanks for your referral.',
    resumeTypeTips: 'File supported: doc, html, docx, pdf, mht, png, jpg, jpeg, bmp',
    submitFailed: 'The candidate you uploaded may be already existed in talent pool. Please contact responsible recruiter for more details.',
    uploadSuccessTips: 'Thanks for your upload.',
    candidateSubmitPolicy: "I confirm the candidate's authorization for this referral submission.",
    agencySubmitPolicy: "As the candidate's authorized recruiting consultant, I confirm the candidate's consent for this submission and will adhere to confidentiality agreements and professional standards."
  },
  message: {
    requireEnter: 'Please enter',
    requireSelect: 'Please select',
    hasUploadedInTalentPool: 'Oops! You cannot upload this candidate. A candidate with this email and/or mobile phone number, already exists in the talent pool.'
  }
}
